import * as React from 'react';
import { Redirect, Route, Switch } from 'react-router';
import { routes } from './config';

import Countries from '../pages/Countries';
import Stores from '../pages/Stores';
import CreateStore from '@ui/scenes/CreateStore';
import EditStore from '@ui/scenes/EditStore';
import Managers from '../pages/Managers';
import Collections from '../pages/Collections';
import { Markets } from '../components/Markets';
import { Factories } from '../components/Factories';
import { Cities } from '../components/Cities';
import { Regions } from '../components/Regions';
import { Report } from 'src/components/Report';
import Requests from '../pages/Requests';

const ContentManagerRoutes = () => (
  <Switch>
    <Route exact path={routes.countries} component={Countries} />
    <Route path={routes.storesCountry} component={Stores} />
    <Route path={routes.createStore} component={CreateStore} />
    <Route path={routes.editStore} component={EditStore} />
    <Route path={routes.managers} component={Managers} />
    <Route path={routes.markets} component={Markets} />
    <Route path={routes.factories} component={Factories} />
    <Route path={routes.cities} component={Cities} />
    <Route path={routes.regions} component={Regions} />
    <Route path={routes.collections} component={Collections} />
    <Route path={routes.report} component={Report} />
    <Route path={routes.requests} component={Requests} />
    <Redirect to={routes.countries} />
  </Switch>
);

export default ContentManagerRoutes;



// WEBPACK FOOTER //
// ./src/Routes/ContentManagerRoutes.tsx